import { candidateFormSchema, CandidateFormValues } from '../../shared/candidate-form-schema';

export const profileFormSchema = candidateFormSchema;

export type ProfileFormValues = CandidateFormValues;
